import BlackTablets from '@propertypal/shared/src/resources/images/2-black-tablets.png';
import PageWrapper from '@propertypal/web-ui/src/layout/PageWrapper';
import { SubHeading, Text } from '@propertypal/web-ui/src/typography';
import React from 'react';
import { Buttons, Container, Content, ImageItem, LastListItem, List, ListItem } from './FeaturesPointsSection.style';
import { AppStore, PlayStore } from './MobileAppsHeaderSection.style';

const FeaturesPointsSection = () => {
  return (
    <Container>
      <PageWrapper>
        <Content>
          <div>
            <SubHeading fontSize={22}>Everything you need, in one place</SubHeading>
            <List>
              <ListItem>
                <Text color="#353535">All the features you love about PropertyPal now on iOS &amp; Android</Text>
              </ListItem>
              <ListItem>
                <Text color="#353535">Stunning, high quality property images</Text>
              </ListItem>
              <ListItem>
                <Text color="#353535">Find properties near you with our helpful location search</Text>
              </ListItem>
              <ListItem>
                <Text color="#353535">Pinpoint accuracy with our innovative &lsquo;Draw a search&rsquo; feature</Text>
              </ListItem>
              <ListItem>
                <Text color="#353535">Search your way, either by list or map</Text>
              </ListItem>
              <ListItem>
                <Text color="#353535">Save your favourite properties so you can easily find them later</Text>
              </ListItem>
              <ListItem>
                <Text color="#353535">Be the first to find the perfect home with our saved search alerts</Text>
              </ListItem>
              <ListItem>
                <Text color="#353535">Whatever your device we&apos;re here for you</Text>
              </ListItem>
              <LastListItem>
                <Text color="#353535">
                  Simply create a PropertyPal.com account, and you&apos;re ready to go. Already have an account? Even
                  better! Once you save your preferences, we&apos;ll hold on to that info, making your search simple.
                </Text>
              </LastListItem>
            </List>

            <Buttons>
              <a href="https://itunes.apple.com/gb/app/propertypal/id583325320?mt=8">
                <AppStore />
              </a>

              <a href="https://play.google.com/store/apps/details?id=com.propertypal.propertysearch">
                <PlayStore />
              </a>
            </Buttons>
          </div>

          <ImageItem src={BlackTablets.src} alt="black tablets" />
        </Content>
      </PageWrapper>
    </Container>
  );
};

export default FeaturesPointsSection;
